import { useNavigate } from 'react-router-dom';

import { Button, sidebar, Typography } from 'shared';

import { useGetCoachingSessionIds } from 'features/sessions/hooks/useGetSessionIds';
import { useSessionNavigationLink } from 'features/sessions/hooks/useSessionNavigationLink';

export const NextSessionInfoGoToSessionButton = ({
  email,
}: {
  email: string;
}) => {
  const { nextSessionId, currentSessionId } = useGetCoachingSessionIds();

  const navigate = useNavigate();

  const sessionLink = useSessionNavigationLink({
    coachingSessionId: nextSessionId,
    email,
  });

  const urlQuery = currentSessionId ? `?prevSessionId=${currentSessionId}` : '';
  const sessionFullLink = `${sessionLink}${urlQuery}`;

  const handleClick = () => {
    sidebar.close();
    navigate(sessionFullLink);
  };

  return (
    <Button
      variant="outline"
      onClick={handleClick}
      w="full"
      data-testid="sidebar-go-to-session"
    >
      <Typography>Go to session</Typography>
    </Button>
  );
};
